export default {
    routes: [
		{
			name: 'yzjc',
			component: () => import('../../view/yzjc/index.vue'),
			meta: {
				title: '业主决策',
				head: true,
				headReturn: true,
				tabbar: false
			}
		},
		{
			path: '/yzjc/yzwyh',
			name: 'yzwyh',
			component: () => import('../../view/yzjc/yzwyh.vue'),
			meta: {
				title: '业主委员会',
				head: true,
				headReturn: true,
				tabbar: false
			}
		},
		{
			path: '/yzjc/wyhdet',
			name: 'wyhdet',
			component: () => import('../../view/yzjc/wyhdet.vue'),
			meta: {
				title: '业主委员会详情',
				head: true,
				headReturn: true,
				tabbar: false
			}
		},
		{
			path: '/yzjc/jctp',
			name: 'jctp',
			component: () => import('../../view/yzjc/jctp.vue'),
			meta: {
				title: '决策投票',
				head: true,
				headReturn: true,
				tabbar: false
			}
		},
		{
			path: '/yzjc/jcdet',
			name: 'jcdet',
			component: () => import('../../view/yzjc/jcdet.vue'),
			meta: {
				title: '决策详情',
				head: true,
				headReturn: true,
				tabbar: false
			}
		},
		{
			path: '/yzjc/vote',
			name: 'vote',
			component: () => import('../../view/yzjc/jcdet.vue'),
			meta: {
				title: '业主决策',
				head: true,
				headReturn: false,
				tabbar: false
			}
		},
		{
			path: '/yzjc/gsdet',
			name: 'gsdet',
			component: () => import('../../view/yzjc/gsdet.vue'),
			meta: {
				title: '公示详情',
				head: true,
				headReturn: true,
				tabbar: false
			}
		},
		{
			path: '/yzjc/gs',
			name: 'gs',
			component: () => import('../../view/yzjc/gs.vue'),
			meta: {
				title: '公示',
				head: true,
				headReturn: true,
				tabbar: false
			}
		},
	]
}